import { apiClient } from '@/api/client';
import type {
  Branch,
  CreateBranchData,
  UpdateBranchData,
} from '@/types/branch.types';

/** What still references a branch. Shown before deactivation is offered. */
export interface BranchUsage {
  rooms: number;
  staff: number;
  futureReservations: number;
  /** Every appointment ever booked at this branch, past and future. */
  totalReservations: number;
}

export const branchesApi = {
  // Get all branches for an clinic
  getAll: async () => {
    const response = await apiClient.get<Branch[]>(`/branches`);
    return response.data;
  },

  // Create a new branch
  create: async (data: CreateBranchData) => {
    const response = await apiClient.post<Branch>(`/branches`, data);
    return response.data;
  },

  // Update a branch
  update: async (branchId: string, data: UpdateBranchData) => {
    const response = await apiClient.put<Branch>(`/branches/${branchId}`, data);
    return response.data;
  },

  /** Counts of rooms, staff and appointments pointing at a branch. */
  getUsage: async (branchId: string) => {
    const response = await apiClient.get<BranchUsage>(
      `/branches/${branchId}/usage`,
    );
    return response.data;
  },

  // Delete a branch (soft delete)
  delete: async (branchId: string) => {
    const response = await apiClient.delete(`/branches/${branchId}`);
    return response.data;
  },

  // Restore an archived branch
  restore: async (branchId: string) => {
    const response = await apiClient.patch(`/branches/${branchId}/restore`);
    return response.data;
  },
};
